<template>
    <li class="nav-item dropdown" id="mySuggestionsLink">
        <el-tooltip
            class="box-item"
            effect="dark"
            :content=" $t('Els meus suggeriments') "
            placement="bottom"
        >
            <a class="nav-link" @click="gotoMysuggestions()">
                <el-icon><List /></el-icon> 
            </a>
        </el-tooltip>
    </li>
</template>

<script>
import {useRouter} from 'vue-router';

export default {
    name: 'MySuggestionsLink',
    setup() {

        const router = useRouter()

        const gotoMysuggestions = () => {
            router.push('/llistat')
        }

        return {gotoMysuggestions}
    }
}
</script>
